export default __webpack_public_path__ + "94b1552ac9fbaf85f5147a681d3d1da2.jpg";